import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'A size set was saved',
  name: 'size_set_created',
  params: [
    {
      description: 'Where the set was saved from',
      name: 'source',
      required: true,
      type: 'enum',
      values: ['canvas_picker', 'chat_follow_up', 'context'],
    },
    {
      description: 'The id of the size set',
      name: 'size_set_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Number of members in the set',
      name: 'member_count',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
